
import {Vue, Component, Prop} from "vue-property-decorator";
import {Getter} from "vuex-class";

@Component({})
export default class OverPriceSms extends Vue {
    @Prop({default: false})
    public dialog: boolean;

    @Prop({default: 0})
    public limit: number;

    @Prop({default: 0.09})
    public overprice: number;

    @Prop({default: false})
    public loading: boolean;

    @Prop({default: "smsLimitReached"})
    public type: string;
}
